import { createContext, useContext } from "react";

export const AdminWorkspaceContext = createContext(false);
export const useAdminWorkspace = () => useContext(AdminWorkspaceContext);
